import {IntermediatePart} from "../../intermediatePart";
export default class Decor extends IntermediatePart {
  constructor(isChild, decorCount) {
    super(isChild);
    this.decorCount = decorCount;
    this.partId = "decor_" + decorCount;
    this.partName = "Decor " + decorCount;
  }
  load(dbFeature) {
    return super.load_(dbFeature, new Decor(false, this.decorCount));
  }

}
